module.exports = __webpack_public_path__ + "static/media/coding.7f82ddda.jpg";